module.exports = __webpack_public_path__ + "img/hero.e2279a8e.png";